import type { ComponentConfig } from '@measured/puck';
import { Container } from '../layout/Container';

export interface LogoCloudProps {
  title?: string;
  logos: { src: string; alt: string }[];
}

export function LogoCloud({ title, logos }: LogoCloudProps) {
  return (
    <section className="bg-stone-50 py-12">
      <Container>
        {title ? (
          <p className="text-center text-sm font-semibold uppercase tracking-[0.16em] text-stone-500">
            {title}
          </p>
        ) : null}
        <div className="mt-6 grid grid-cols-2 items-center gap-6 sm:grid-cols-3 lg:grid-cols-6">
          {logos.map((logo) => (
            <img
              key={logo.alt}
              src={logo.src}
              alt={logo.alt}
              loading="lazy"
              width={120}
              height={40}
              className="mx-auto h-10 w-auto opacity-70 grayscale transition hover:opacity-100 hover:grayscale-0"
            />
          ))}
        </div>
      </Container>
    </section>
  );
}

export const LogoCloudConfig: ComponentConfig<LogoCloudProps> = {
  fields: {
    title: { type: 'text' },
    logos: {
      type: 'array',
      arrayFields: { src: { type: 'text' }, alt: { type: 'text' } },
      defaultItemProps: { src: '', alt: '' },
    },
  },
  defaultProps: {
    title: 'Ils nous font confiance',
    logos: [],
  },
  render: LogoCloud,
};
